import { render } from "./OrganizationDetail.vue?vue&type=template&id=2b86d35c"
import script from "./OrganizationDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__